import * as Sentry from '@sentry/react';
import config from '../config';

export default class ErrorsService {
  public start() {
    Sentry.init({
      enabled: config.env !== 'development',
      dsn: 'https://17c8401b1c644d1783ece070a9a30954@o559414.ingest.sentry.io/5694145',
      environment: config.env,
    });
  }

  public setUser(userId: string, email: string | null): void {
    Sentry.setUser({ id: userId, email: email ?? undefined });
  }

  public resetUser(): void {
    Sentry.configureScope((scope) => scope.setUser(null));
  }

  // this is always called from the useErrors hook
  public report(err: any): void {
    Sentry.captureException(err);
  }
}
